<script lang="ts" setup>
import { computed } from 'vue'
import { CountryISO3, CurrencyFlag } from '@previo/codebooks'
import { PFlagSize } from './types'

type Props = {
  countryIso3?: CountryISO3
  currencyFlag?: CurrencyFlag
  size?: PFlagSize
}

const props = withDefaults(defineProps<Props>(), {
  size: PFlagSize.LARGE,
})

const cssClassSize = computed<string>(() => {
  switch (props.size) {
    case PFlagSize.LARGE:
      return 'ds-flag-large'
    case PFlagSize.SMALL:
      return 'ds-flag-small'
    case PFlagSize.SMALLEST:
      return 'ds-flag-smallest'

    default:
      throw 'Invalid props of size in PFlag'
  }
})
const url = computed<string>(() => {
  let flagCode = props.countryIso3?.toUpperCase()
  if (props.currencyFlag) {
    flagCode = props.currencyFlag.toUpperCase()
  }
  return new URL(`../../assets/flags/rectangle/${flagCode}.svg`, import.meta.url).href
})
</script>

<template>
  <img :class="`ds-flag ds-flag__circle ${cssClassSize}`" :src="url" alt="flag" />
</template>

<style lang="scss" scoped>
@import '../../assets/scss/restricted/quasar.variables';

.ds-flag {
  border-radius: $button-border-radius;
  border: 1px solid getColor('grey300');
  max-height: 48px;
  height: 48px;

  &__circle {
    max-height: 48px;
    height: 48px;
    aspect-ratio: 1;
    border-radius: 50%;
    object-fit: cover;
  }
  &-large {
    max-height: 40px;
    height: 40px;
  }
  &-small {
    max-height: 24px;
    height: 24px;
  }
  &-smallest {
    max-height: 20px;
    height: 20px;
  }
}
</style>
